import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'phoenix',
    loadChildren: () => import('./magnament/magnament.module').then(m => m.MagnamentModule)
  },{
    path: 'login',
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
  },{
    path: 'loginManager',
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
  },{
    path: 'loginTutor',
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
  },{
    path: 'loginProfessor',
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
  },{
    path: 'login/logout',
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
  },{
    path: 'loginManager/logout',
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
  },{
    path: 'loginTutor/logout',
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
  },{
    path: 'loginProfessor/logout',
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
  },{
    path: 'login/error',
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
  },{
    path: 'loginManager/error',
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
  },{
    path: 'loginTutor/error',
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
  },{
    path: 'loginProfessor/error',
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
  },{
    path: 'singleThread/:obj',
    loadChildren: () => import('./magnament/forumData/singleThread/singleThread.module').then(m => m.SingleThreadModule)
  },{
    path: '',
    redirectTo: '/phoenix',
    pathMatch: 'full'
  }
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, useHash: true })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
